import styled from "styled-components";
import { Icon, RowView } from "../../../../Component/style/common_style";
import { useRef, useState } from "react";

interface Step1Props {
  name: string;
  handleName: (e: React.ChangeEvent<HTMLInputElement>) => void;
  phoneNum: string;
  handlePhoneNum: (e: React.ChangeEvent<HTMLInputElement>) => void;
  email: string;
  handleEmail: (e: React.ChangeEvent<HTMLInputElement>) => void;
  domain: string;
  handleDomain: (e: React.ChangeEvent<HTMLInputElement> | string) => void;
  selectDomain: string;
  handleSelectDomain: (data: string) => void;
}

const Step1 = ({
  name,
  handleName,
  phoneNum,
  handlePhoneNum,
  email,
  handleEmail,
  domain,
  handleDomain,
  selectDomain,
  handleSelectDomain,
}: Step1Props) => {
  const emailList = [
    "naver.com",
    "gmail.com",
    "hanmail.net",
    "daum.net",
    "직접입력",
  ];
  const [itemboxOpen, setItemboxOpen] = useState(false);
  const open_itembox = () => setItemboxOpen(!itemboxOpen);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const boxopen_class = () => {
    if (itemboxOpen) return "open";
    return "";
  };

  return (
    <>
      <Title>
        대표자명 <span style={{ color: "red" }}>*</span>
      </Title>
      <InsertDiv>
        <InsertInput
          type="text"
          placeholder="대표자명을 입력해주세요."
          value={name}
          onChange={handleName}
        />
      </InsertDiv>
      <Title>
        연락처 <span style={{ color: "red" }}>*</span>
      </Title>
      <InsertDiv>
        <InsertInput
          type="number"
          placeholder="- 를 제외한 연락처를 입력해주세요."
          value={phoneNum}
          onChange={handlePhoneNum}
        />
      </InsertDiv>
      <Title>
        이메일 <span style={{ color: "red" }}>*</span>{" "}
        <span style={{ fontSize: 14, color: "#8E8E8E" }}>
          고객들에게 문의 받을 이메일을 등록해주세요.
        </span>
      </Title>
      <RowView style={{ marginTop: 10 }}>
        <EmailInsertDiv>
          <InsertInput type="text" value={email} onChange={handleEmail} />
        </EmailInsertDiv>
        <div style={{ marginRight: 12, marginLeft: 12, color: "#8e8e8e" }}>
          @
        </div>
        <EmailInsertDiv $disabled={selectDomain !== "직접입력"}>
          <InsertInput
            type="text"
            value={domain}
            onChange={handleDomain}
            disabled={selectDomain !== "직접입력"}
          />
        </EmailInsertDiv>
      </RowView>
      <Select ref={dropdownRef}>
        <ItemBox className={boxopen_class()} onClick={open_itembox}>
          <div className="gray">
            {selectDomain === "" ? "선택" : selectDomain}
          </div>

          <Icon src={require("../../../../Image/ic_down_black.png")} />
        </ItemBox>

        <ItemList className={boxopen_class()}>
          {emailList.map((data, idx) => {
            return (
              <div
                key={idx}
                style={idx === 0 ? { borderTop: 0 } : {}}
                onClick={() => {
                  handleSelectDomain(data);
                  data === "직접입력" ? handleDomain("") : handleDomain(data);
                  open_itembox();
                }}
              >
                {data}
              </div>
            );
          })}
        </ItemList>
      </Select>
    </>
  );
};

export default Step1;

const Title = styled.div`
  font-family: var(--font-Pretendard-Medium);
  margin-top: 30px;
`;

const InsertDiv = styled.div`
  flex-direction: row;
  display: flex;
  background-color: white;
  border-radius: 8px;
  border: 1px solid #f0f0f0;
  width: 100%;
  height: 50px;
  justify-self: center;
  align-items: center;
  justify-content: flex-start;
  padding: 12px;
  box-sizing: border-box;
  margin-top: 10px;
`;

const InsertInput = styled.input`
  margin-left: 4px;
  font-size: 16px;
  color: black;
  background-color: transparent;
  border: none;
  outline: none;
  width: 100%;
  /* 화살표 제거 - Chrome, Safari, Edge */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* 화살표 제거 - Firefox */
  &[type="number"] {
    -moz-appearance: textfield;
  }
`;

const EmailInsertDiv = styled.div<{ $disabled?: boolean }>`
  flex-direction: row;
  display: flex;
  background-color: ${(props) => (props.$disabled ? "#FBFBFB" : "transparent")};
  border-radius: 8px;
  border: 1px solid #f0f0f0;
  width: 100%;
  height: 50px;
  justify-self: center;
  align-items: center;
  justify-content: flex-start;
  padding: 12px;
  box-sizing: border-box;
`;

const Select = styled.div`
  position: relative;
  margin-top: 10px;
`;
const ItemBox = styled(RowView)`
  padding: 0.8rem 1rem;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  cursor: pointer;
  div.gray {
    color: #8e8e8e;
  }
  &.open {
    border-radius: 8px 8px 0px 0px;
    border-bottom: 0;
  }
`;
const ItemList = styled.div`
  position: absolute;
  display: none;
  top: 100%;
  left: 0;
  right: 0;
  max-height: 29rem;
  background-color: white;
  border-top: 0;
  border: 1px solid #f0f0f0;
  overflow: auto;
  cursor: pointer;
  &::-webkit-scrollbar {
    width: 12px;
    background-color: #f8f8f8;
  }
  &::-webkit-scrollbar-thumb {
    background: #d9d9d9;
    &:hover {
      background: #ababab;
    }
  }
  div {
    padding: 0.8rem 1rem;
    border-top: 1px solid #f0f0f0;
    &:hover {
      background-color: #f8f8f8;
    }
  }
  &.open {
    display: block;
  }
`;
